import { useState ,useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Divider, Modal, CardContent, Table, TableBody, TableCell, TableContainer, TableRow, TableHead } from '@mui/material';
import { getEquipmentCategoriesByQuery, getMasterEquipmentPartsByQuery } from 'components/axios/equipmentCategoryAxios';
import MainCard from 'components/MainCard';
import AvgLifeTime from 'components/AvgLifeTime';
import { getTimeString } from 'data/data';
import Chip from '@mui/material/Chip';

export function EquipmentPartListLayer({equipmentCtgrId}) {
  
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [equipmentCategoryComponents, setEquipmentCategoryComponents] = useState([]);
  const [masterEquipmentParts, setMasterEquipmentParts] = useState([]);
  const [equipmentCategoryComponentsSelected, setEquipmentCategoryComponentsSelected] = useState([]);
  const [equipmentCategoryComponentId, setEquipmentCategoryComponentId] = useState(0);

  useEffect(()=>{
    if (open) {
      equipmentCategoryComponentList();
    }
  },[open]);

  // 설비구성부 목록
  const equipmentCategoryComponentList = async () => {
    const param = { "parent.id": equipmentCtgrId, depth: 4, size : 100, sort : "name,asc" };
    await getEquipmentCategoriesByQuery(param).then((data) => {
      if (data  && data._embedded) {
        const list = data._embedded.equipmentCategories;
        if (list) {
          setEquipmentCategoryComponents(list);

          let arr2 = Array.from({ length: list.length }, () => null);
          setEquipmentCategoryComponentsSelected(arr2);
          selectEquipmentCategoryComponent(0, list[0]);
        } else {
          setEquipmentCategoryComponents([]);
        }
      } else {
        setEquipmentCategoryComponents([]);
      }
    });
  };

  // 설비구성부 선택
  const selectEquipmentCategoryComponent = (i, data) => {
    setEquipmentCategoryComponentId(data.id);
    let copy = [...equipmentCategoryComponentsSelected];
    copy = Array.from({ length: copy.length }, () => null);
    copy[i] = "bold";
    setEquipmentCategoryComponentsSelected(copy);
    masterEquipmentPartList();
  };

  // 자재 목록
  const masterEquipmentPartList = async () => {
    const param = { "equipmentCtgr.id": equipmentCategoryComponentId, size:100, sort : "name,asc" };
    await getMasterEquipmentPartsByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.masterEquipmentParts;
        if (list) {
          setMasterEquipmentParts(list);
        } else {
          setMasterEquipmentParts([]);
        }
      } else {
        setMasterEquipmentParts([]);
      }
    });
  };

    return (
    <>
      <Button variant="contained" style={{padding:"2px 5px"}} color="primary" onClick={handleOpen} >{t('message.common.btn.material.classification.view')}</Button>

      <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <MainCard modal darkTitle content={false}>
          <div style={{marginBottom:"7px"}}>
            <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
            <Chip label={t('message.common.chip.material.classification.list')} color="success" />
          </div>

          <CardContent>
            <div style={{display:"flex"}}>
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.equipment.component')}</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody style={{display:"block",height:"500px",overflowY:"scroll"}}>
                  { equipmentCategoryComponents && equipmentCategoryComponents.map(function(con, i) {
                      return (
                    <TableRow key={i}>
                      <TableCell style={{cursor:"pointer", fontWeight : equipmentCategoryComponentsSelected[i]}} onClick={()=>{
                          selectEquipmentCategoryComponent(i, equipmentCategoryComponents[i]);
                        }}>
                          {equipmentCategoryComponents[i].name}
                        </TableCell>
                    </TableRow>
                      );
                  }) }
                  </TableBody>
                </Table>
                </TableContainer>

                <TableContainer>
                  <Table aria-label="simple table">
                    <colgroup>
                      <col width="300px" />
                      <col width="150px" />
                      <col width="150px" />
                      <col width="150px" />
                    </colgroup>
                    <TableHead>
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.material')}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.self.management.cycle')}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.alarm.standard')}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.peer.average')}</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                    { masterEquipmentParts && masterEquipmentParts.map(function(con, i) {
                        return (
                      <TableRow key={i}>
                        <TableCell style={{}}>
                          {masterEquipmentParts[i].name}
                        </TableCell>
                        <TableCell style={{}}>
                          {masterEquipmentParts[i].lifeSpanTime && getTimeString(masterEquipmentParts[i].lifeSpanTime)}
                        </TableCell>
                        <TableCell style={{}}>
                          {masterEquipmentParts[i].alertTime && getTimeString(masterEquipmentParts[i].alertTime)}
                        </TableCell>
                        <TableCell style={{}}><AvgLifeTime masterEquipmentPartId={masterEquipmentParts[i].id}/></TableCell>
                      </TableRow>
                        );
                    }) }
                    </TableBody>
                  </Table>
                </TableContainer>
            </div>
            <div style={{textAlign:"right"}}>
              <Button variant="contained" size="small" onClick={handleClose}>
                {t('message.common.btn.close')}
              </Button>
            </div>
          </CardContent>
          <Divider />

        </MainCard>
      </Modal>
    </>
    )
}

export default EquipmentPartListLayer;
